import { AppState } from 'types/app';
import { selectIsFeatureMafiaAkamai } from 'selectors/features';
import marketplace from 'cfg/marketplace.json';

export const selectEnvironment = (state: AppState) => state.environmentConfig || {};

export const selectApiConfig = (state: AppState) => selectEnvironment(state).api || {};

export const selectCloudCatalogApi = (state: AppState) => selectEnvironment(state).api.cloudcatalog || {};

export const selectIsMockApi = (state: AppState) => selectEnvironment(state).isMockApi;

export const selectVisualSearchMafiaURL = (state: AppState) => selectEnvironment(state).visualSearch?.mafiaBaseUrl;

export const selectMafiaConfig = (state: AppState) => {
  const isFeatureMafiaAkamai = selectIsFeatureMafiaAkamai(state);
  const mafiaConfig = selectApiConfig(state).mafia || {};

  // Fallback if state values are not available
  if (!Object.keys(mafiaConfig).length) {
    return { ...mafiaConfig, url: marketplace.api.mafia.url };
  }

  return { ...mafiaConfig, url: isFeatureMafiaAkamai ? mafiaConfig.akamaiUrl : mafiaConfig.url };
};

export const selectVisualSearchMafiaConfig = (state: AppState) => {
  const mafiaConfig = selectApiConfig(state).mafia || {};
  const mafiaBaseUrl = selectVisualSearchMafiaURL(state) ?? marketplace.api.mafia.url;

  return { ...mafiaConfig, url: mafiaBaseUrl };
};

export const selectAccountConfig = (state: AppState) => {
  const isFeatureMafiaAkamai = selectIsFeatureMafiaAkamai(state);
  const accountConfig = selectApiConfig(state).account || {};

  // Fallback if state values are not available
  if (!Object.keys(accountConfig).length) {
    return { ...accountConfig, url: isFeatureMafiaAkamai ? marketplace.api.mafia.akamaiUrl : marketplace.api.mafia.url };
  }

  return { ...accountConfig, url: isFeatureMafiaAkamai ? accountConfig.akamaiUrl : accountConfig.url };
};
